import React from 'react'
import './FabOurTeam.css'
import ourTeam1 from '../../../public/ourTeam1.jpg'
import ourTeam2 from '../../../public/ourTeam2.jpg'
import ourTeam3 from '../../../public/ourTeam3.jpg'
import { useNavigate } from 'react-router-dom'

function FabOurTeam() {
  const navigate = useNavigate();
  return (
    <div className="fab_ourTeam_container">
      <h1>BECOME PART OF FAB</h1>
      <div className="ourTeam_information_container">
        {[{
          img: ourTeam1,
          title: 'EXPANSION PARTNER',
          desc: `League Expansion Partner plays a pivotal role in building brand awareness and spearheading the expansion into untapped markets. Working under FAB’s license, you will enjoy the autonomy to implement strategic initiatives and drive growth in accordance with FAB’s vision.`,
        }, {
          img: ourTeam2,
          title: 'BECOME AN OFFICIAL',
          desc: `We provide comprehensive training and support to all our referees, equipping you with the knowledge and skills needed to excel on the court. Whether you're a seasoned referee or just starting out, there's a place for you on our team.`,
        }, {
          img: ourTeam3,
          title: 'BECOME A SCOREKEEPER',
          desc: `As a scorekeeper, you'll play a vital role in ensuring smooth and accurate game operations. You'll be responsible for tracking scores, fouls, timeouts, and other essential game details, helping to maintain the integrity and fairness of each match.`,
        }].map(({ img, title, desc }, idx) => (
          <div key={idx} className="ourTeam_card">
            <img src={img} alt={title} />
            <h4>{title}</h4>
            <p>{desc}</p>
            <button onClick={() => navigate('/contact')}>Learn More</button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FabOurTeam
